// Opening Twinden clears its notifications, the way WhatsApp does: once the
// app is in front, the chats themselves show what's new. A call that is still
// ringing keeps its notification; the call screen handles it.

/** Whether a notification should go once the app is in front. */
export function clearsOnOpen(
  tag: string,
  ringingCallId: string | null
): boolean {
  return !(ringingCallId && tag === `call:${ringingCallId}`);
}

export async function clearNotificationsOnOpen(
  ringingCallId: string | null
): Promise<void> {
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    const notifications = await registration?.getNotifications();
    notifications?.forEach((notification) => {
      if (clearsOnOpen(notification.tag, ringingCallId)) notification.close();
    });
  } catch {
    // No service worker (dev, unsupported browser): nothing to clear.
  }
}
